import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
	providedIn: 'root', // Available across the whole app
})
export class MessageAlertService {
	constructor(private messageService: MessageService) {}

	/**
	 * Displays a toast message using PrimeNG MessageService.
	 * @param severity Type of message ('success', 'info', 'warn', 'error').
	 * @param summary Short title for the message.
	 * @param detail Detailed message.
	 * @param lifeMs Optional time in ms before auto-dismiss (default PrimeNG ~3000).
	 *   Use longer (8000-10000) for notifications the user must definitely see.
	 */
	showMessage(
		severity: 'success' | 'info' | 'warn' | 'error',
		summary: string,
		detail: string,
		lifeMs?: number,
	): void {
		this.messageService.add({ severity, summary, detail, ...(lifeMs && { life: lifeMs }) });
	}

	/**
	 * Displays a toast message with a specific key (for multiple toast instances with different styles).
	 * @param severity Type of message ('success', 'info', 'warn', 'error').
	 * @param summary Short title for the message.
	 * @param detail Detailed message.
	 * @param key Unique key to identify which toast container to use.
	 */
	showMessageWithKey(
		severity: 'success' | 'info' | 'warn' | 'error',
		summary: string,
		detail: string,
		key: string,
	): void {
		this.messageService.add({ severity, summary, detail, key });
	}
}
